import script from "./ViewWriting.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWriting.vue?vue&type=script&setup=true&lang=js"

import "./ViewWriting.vue?vue&type=style&index=0&id=3a7104e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7104e0"]])

export default __exports__